import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/wms/api')

export interface Warehouse {
  id: number
  tenant_id: number
  code: string
  name: string
  address: string
  status: Status
  created_at: string
  updated_at: string
}

export interface WarehouseInput {
  code: string
  name: string
  address: string
  status: Status
}

export interface WarehouseQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/wms/internal/warehouse 的字典保持一致，改一边必须改另一边 */
export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

export const listWarehouses = (q: WarehouseQuery): Promise<PageResult<Warehouse>> =>
  api.get<PageResult<Warehouse>>('/warehouses', { ...q })

export const createWarehouse = (input: WarehouseInput): Promise<Warehouse> =>
  api.post<Warehouse>('/warehouses', input)

export const updateWarehouse = (id: number, input: WarehouseInput): Promise<Warehouse> =>
  api.put<Warehouse>(`/warehouses/${id}`, input)
